module.exports = __webpack_public_path__ + "static/img_branding_conf_and_fest@2x-df3c3331300b5adc50d8ecbcdff8e970.png";